<template>
  <div class="profile">
    <el-row>
      <el-col :offset="8" :lg="8" :md="8" :xl="8" :xs="24" class="mobileProfile">
        <div class="avatar">
          <img v-if="user.profile_picture" :src="user.profile_picture"/>
          <uploader class="upload-container" :item="user" :action="API_HOST + '/api/order.php?api=upload_good_picture'" v-on:onUploadSuccess="onUploadSuccess" icon="icon-camera">
          </uploader>
        </div>
        <dl>
          <dt>用户信息</dt>
          <dd>
            <el-form ref="user" :model="user" :rules="userRules">
              <el-form-item prop="express">
                <YueDanIpt class="group" :readonly="true" model="username" :object="user" placeholder="用户名">
                  <!--<Username v-if="user.username_changed == 0" :user="user"><a style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;">更改</a></Username>-->
                </YueDanIpt>
                <YueDanIpt class="group" :readonly="true" model="mobile" :object="user" placeholder="手机号">
                  <Mobile :user="user">
                    <a v-if="user.mobile" style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;">更改</a>
                    <a v-else style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;">绑定</a>
                  </Mobile>
                </YueDanIpt>
                <YueDanIpt class="group" :readonly="true" model="wechat" :object="user" placeholder="微信昵称">
                  <WeChat v-if="!unbinding" v-on:success="bindSuccess">
                    <a style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;">绑定</a>
                  </WeChat>
                  <a v-if="unbinding" @click="dialogFormVisible=true" style="position:absolute;top:4px;right:15px;z-index:99;cursor:pointer;">解绑</a>
                  <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
                    <h1 class="text-center">解绑微信账号</h1>
                    <div class="img">
                        <img width="220" src="../../assets/images/homepage/weixin.svg" />
                    </div>
                    <div class="text-center">
                      <p style="line-height: 2;">
                          JoyOrders账号与微信解除绑定后，
                      </p>
                      <p style="line-height: 1;">
                          将无法使用微信登录，并且无法接收微信提醒
                      </p>
                    </div>
                    <div class="confirm" @click="relieve()">
                      确 定
                    </div>
                  </el-dialog>
                </YueDanIpt>
              </el-form-item>
              <el-form-item prop="email">
                <YueDanIpt model="email" :object="user" placeholder="邮箱"></YueDanIpt>
              </el-form-item>
              <el-button :loading="userLoading" class="block" type="primary" @click="saveInfo()">修改邮箱</el-button>
            </el-form>
          </dd>
          <dt>所在地区</dt>
          <dd>
            <el-form ref="location" :model="user" :rules="locationRules">
              <el-form-item prop="country">
                <el-select class="height-50" v-model="user.country" placeholder="请选择地区" style="width: 100%;">
                  <el-option
                    v-for="item in COUNTRIES"
                    :key="item.value"
                    :label="item.name+'('+item.value+')'"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="12">
                   <el-form-item prop="province">
                    <YueDanIpt model="province" :object="user" placeholder="城市"></YueDanIpt>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                   <el-form-item prop="city">
                    <YueDanIpt model="city" :object="user" placeholder="州/省"></YueDanIpt>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button :loading="locationLoading" class="block" type="primary" @click="saveLocation()">保存地址</el-button>
            </el-form>
          </dd>
          <dt>修改密码</dt>
          <dd>
            <el-form ref="password" :model="user" :rules="passwordRules">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="old_password">
                    <YueDanIpt type="password" model="old_password" :object="user" placeholder="旧密码"></YueDanIpt>
                    <div v-if="wrongPassword" class="el-form-item__error">
                      请输入正确旧密码
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                   <el-form-item prop="new_password">
                    <YueDanIpt type="password" model="new_password" :object="user" placeholder="新密码"></YueDanIpt>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button :loading="passwordLoading" class="block" type="primary" @click="savePassword()">修改密码</el-button>
            </el-form>
          </dd>
        </dl>
      </el-col>
    </el-row>
    <el-dialog v-if="editSuccess" class="el-dialog-sm el-dialog-sm-h3" :visible.sync="editSuccess" width="90%" @close="showForm = false">
      <div class="text-center redirct">
        <p><i class="ico ico-paysucces completion"></i></p>
        <h1 style="padding: 60px 0 25px;">密码修改成功</h1>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uploader from '../../components/Uploader';
import Username from './components/Username';
import Mobile from './components/Mobile';
import WeChat from './components/WeChat';
import YueDanIpt from '../../components/YueDanIpt'
import { COUNTRIES } from '../../services/constant'
import { API_HOST, FILE_HOST } from '../../services/constant.js'
import api from '../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['order', 'packageId', 'groupOrderLine'],
  components: {
    YueDanIpt: YueDanIpt,
    Uploader: Uploader,
    Username: Username,
    Mobile: Mobile,
    WeChat: WeChat
  },
  computed: {
  },
  data () {
    var checkOldPassword = (rule, value, callback) => {
      this.wrongPassword = false
      if (!value) {
        callback(new Error('旧密码是必填项'))
      } else {
        callback();
      }
    }

    return {
      editSuccess:false,
      unbinding: false,
      API_HOST: API_HOST,
      user: {},
      location: {},
      wrongPassword: false,
      userRules: {
        email: [
          { required: true, pattern: /[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请输入正确的邮箱', trigger: 'blur' }
        ]
      },
      locationRules: {
        country: [
          { required: true, message: '国家是必选项', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '城市是必填项', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '州/省是必填项', trigger: 'blur' }
        ]
      },
      passwordRules: {
        old_password: [
          { validator: checkOldPassword, trigger: 'blur' }
        ],
        new_password: [

          { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$/, message: '密码长度至少为8 位，且必须同时包含大写字母、小写字母和数字', trigger: 'blur' }
        ]
      },
      userLoading: false,
      locationLoading: false,
      passwordLoading: false,
      COUNTRIES: COUNTRIES,
      loading: false,
      dialogFormVisible: false
    }
  },
  created () {
    this.getBindStatus()
  },
  methods: {
    getBindStatus () {
      let url = API_HOST +'/wechat/api.php?api=get_bind_status'
      this.$http.get(url).then(data =>{
        if(data.body.status ==  'ok'){
          if(data.body.result == 'bind') {
              this.unbinding = true
            }else{
              this.unbinding = false
            }
          this.getUserInfo()
        }
          
      })
    },
    bindSuccess () {
      this.unbinding=true
      this.getUserInfo()
    },
    relieve () {
      let url = API_HOST +'/wechat/api.php?api=unbind_user'
      this.$http.get(url).then(data =>{
          if(data.body.result === 'success') {
            this.unbinding = false
            this.dialogFormVisible = false
            this.getUserInfo()
          }
      })

    },
    async getUserInfo () {
      let { body } = await api.getUserInfo(this)
      if(body.status === 'ok'){
        let result = body.result
        this.user = result
        if(this.user.wechat && this.unbinding){
          this.user.wechat = result.wechat.nickname
        }else{
          this.user.wechat = ''
        }
      }
    
    },
    // getWeChatInfo () {
    //   let url = API_HOST +'/wechat/buyer.php?api=get_info'
    //   this.$http.get(url).then(data =>{
          
    //   })
    // },
    async saveInfo () {
      this.$refs['user'].validate(async (valid, errors) => {
        if (valid) {
          let res = await api.post(this, {
            path: 'buyer.php',
            api: 'update_email', 
            data: {
              email: this.user.email
            },
            loading: 'userLoading'
          })
        } else {
          return false
        }
      })
    },
    async saveLocation () {
      this.$refs['location'].validate(async (valid, errors) => {
        if (valid) {
          let res = await api.post(this, {
            path: 'buyer.php',
            api: 'update_location',
            data: {
              country: this.user.country,
              province: this.user.province,
              city: this.user.city
            },
            loading: 'locationLoading'
          })
        } else {
          return false
        }
      })
    },
    async savePassword () {
      this.$refs['password'].validate(async (valid, errors) => {
        this.wrongPassword = false
        if (valid) {
          let {body} = await api.post(this, {
            path: 'passport.php',
            api: 'update_password',
            data: {
              old_password: this.user.old_password,
              new_password: this.user.new_password
            },
            loading: 'passwordLoading'
          })
          if (body.result == 'wrong_old_password') {
            this.wrongPassword = true
          } else {
            this.wrongPassword = false
            this.editSuccess = true
          }
          console.log('bodybody', body)
        } else {
          return false
        }
      })
    },
    async onUploadSuccess (res) {
      let result = res.response.result
      this.user.profile_picture = result
      await api.post(this, {
        path: 'buyer.php',
        api: 'upload_profile_picture',
        data: {
          picture: this.user.profile_picture
        },
        loading: 'passwordLoading'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .avatar {
    overflow:hidden;
    margin: 0 auto;
    width: 80px;
    height: 80px;
    border-radius: 100%;
    background-color: #ddd;
    margin-bottom: 30px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .upload-container {
      position: absolute;
      height: 23px;
      z-index: 99;
      overflow: hidden;
      bottom: 0;
    }
  }
  dt {
    margin-top: 30px;
    margin-bottom: 10px;
  }
  .img {
    text-align: center;
    margin-top: 20px;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .confirm {
    display: inline-block;
    margin-bottom: 20px;
    margin-top: 30px;
    width: 100%;
    height: 45px;
    border-radius: 3px;
    border: 1px solid #0f66cf;
    vertical-align: top;
    color: #0F66CF;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
  .redirct {
    font-size:24px;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
</style>

<style lang="scss">
  .profile {
    .avatar {
      .el-upload--picture-card {
        height: 80px;
        width: 80px;
        border-radius: 100%;
        background-color: #666666;
        border: none;
        position: relative;
        top: -57px;

        .icon-camera {
          position: relative;
          top: -3px;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
@media screen and (max-width:1024px){
  .mobileProfile {
    margin-left: 0px !important;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user_center/Profile.vue